import { BiComment, BiPencil } from "react-icons/bi";
import { PaddedIcon } from "../../components/ui/button/Icon";
import Workspace from "../../components/workspace";

const ServiceReport = ({ serviceReport, formModal, commentModal, setSelected }) => {
   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(serviceReport);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <div className="col-span-8 overflow-hidden overflow-ellipsis">
                  <p className="font-bold">{`${serviceReport.serviceDate} | ${serviceReport.name}`}</p>
                  <small className="">
                     <b>Title: </b>
                     <i>{serviceReport.sermonTitle}</i>
                  </small>
               </div>

               <small className="col-span-2" title="Branch">
                  {serviceReport.branchCode}
               </small>

               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary" aria-label="edit">
                     <BiPencil className="text-lg" />
                  </PaddedIcon>
                  <PaddedIcon
                     variant="secondary"
                     aria-label="Comments"
                     as="button"
                     onClick={(e) => {
                        e.stopPropagation();
                        setSelected(serviceReport);
                        commentModal.onOpen();
                     }}>
                     <BiComment className="text-lg" />
                  </PaddedIcon>
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export { ServiceReport };
